import React from "react";
import { Link } from "react-router-dom";
import { Tag, Zap, Camera } from "lucide-react";
import { company } from "../data/mock";
import { useCurrentPromo, promoText, promoMatchLine, promoTheme, promoImage } from "../lib/promo";

export const QuotePromoBanner = () => {
  const p = useCurrentPromo();
  if (!p) return null;
  return (
    <div className="mb-5 flex items-start gap-3 bg-[#fff4e6] border border-orange-200 rounded-xl px-4 py-3" data-testid="promo-banner">
      <Tag className="w-5 h-5 text-orange-600 shrink-0 mt-0.5" />
      <p className="text-sm text-orange-900"><strong>{p.name} special: {promoText(p)}</strong> {promoMatchLine(p)}</p>
    </div>
  );
};

export const HomePromoBanner = () => {
  const p = useCurrentPromo();
  if (!p) return null;
  const img = promoImage(p);
  const spooky = !!img;
  return (
    <section data-testid="home-promo-banner" data-theme={promoTheme(p)} className={`relative overflow-hidden text-white ${spooky ? "bg-[#140b1f]" : "bg-gradient-to-r from-[#ff7a1a] to-[#f05a00]"}`}>
      {spooky && (
        <>
          <img src={img} alt="" aria-hidden="true" data-testid="home-promo-bg" className="absolute inset-0 w-full h-full object-cover object-[center_60%]" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#140b1f] via-[#140b1f]/70 to-transparent" />
        </>
      )}
      <div className={`relative max-w-[1280px] mx-auto px-5 lg:px-8 flex flex-col lg:flex-row lg:items-center gap-5 ${spooky ? "py-10 md:py-14" : "py-6 md:py-7"}`}>
        <div className="flex-1">
          <p className={`text-xs font-bold uppercase tracking-[0.2em] ${spooky ? "text-[#ff8a2b]" : "text-orange-100"}`} data-testid="home-promo-name">{p.name} special</p>
          <p className="mt-1 max-w-2xl text-xl md:text-3xl font-extrabold leading-snug" data-testid="home-promo-text">{promoText(p)}</p>
          {p.match_beat && <p className={`mt-2 max-w-2xl text-sm md:text-base ${spooky ? "text-slate-200" : "text-orange-50"}`} data-testid="home-promo-match">{promoMatchLine(p)}</p>}
        </div>
        <div className="flex flex-wrap gap-3">
          <Link to="/tv-mounting-quote" data-testid="home-promo-quote-btn" className={`inline-flex items-center gap-2 px-6 py-3 rounded-full font-bold transition-colors ${spooky ? "bg-[#ff7a1a] text-white hover:bg-[#f05a00] shadow-lg shadow-orange-900/40" : "bg-white text-[#c2410c] hover:bg-orange-50"}`}>
            <Zap className="w-4 h-4" /> Instant Quote
          </Link>
          <a href={company.photoSms} data-testid="home-promo-text-btn" className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-white/70 font-bold hover:bg-white/10 transition-colors">
            <Camera className="w-4 h-4" /> Text {company.phone}
          </a>
        </div>
      </div>
    </section>
  );
};
